/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable array-callback-return */

import React, { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import { HeaderWrapper } from './components/header'
import { Content } from './components/content'
import { FooterWrapper } from './components/footer'
import { Sidebar } from './components/sidebar'
import { ActivityDrawer, DrawerMessenger, InviteUsers, UpgradePlan } from '../partials'
import { PageDataProvider } from './core'
import { reInitMenu } from '../helpers'
import { useDispatch, useSelector } from 'react-redux'
import { getCard } from '../../redux/action/card'
import { toggleAdminPermissionMode } from '../../redux/action/account'
// import { ToolbarWrapper } from './components/toolbar' //omitted due to eslint warning
// import { ScrollTop } from './components/scroll-top' //omitted due to eslint warning
// import {RightToolbar} from '../partials/layout/RightToolbar' //omitted due to eslint warning

const MasterLayout = () => {
  const location = useLocation()
  const dispatch = useDispatch()
  const Allcard = useSelector((state: any) => state.Card?.UserCard)
  const userId = useSelector((state: any) => state._id)

  const [hasActiveScenes, setHasActiveScenes] = React.useState<any>(false)
  // const ngrokip:any = process.env.REACT_APP_NGROK_FRONTEND_URL;
  // const testmode = localStorage.getItem('testmode')
  // const environment = process.env.REACT_APP_ENVIRONMENT;
  // const handleProductionMode = async () => {
  //   window.location.href = ngrokip + '?testmode=production';
  // }

  // const handleStagingMode = async () => {
  //   window.location.href = ngrokip +  '?testmode=staging';
  // }

  // const handleLocalMode = async () => {
  //   localStorage.setItem('testmode', '')
  //   window.location.href = 'http://localhost:3000'
  // }

  useEffect(() => {
    handleGetAllCard()
  }, [userId])

  const handleGetAllCard = () => {
    if (userId) {
      dispatch(getCard({ userId }))
    }
  }

  useEffect(() => {
    console.log("hasActiveScenes", hasActiveScenes)
    Allcard.map((scene: any) => {
      if (scene?.protected?.isActive) {
        setHasActiveScenes(true)
      }
    })


  }, [Allcard])


  useEffect(() => {
    reInitMenu()
  }, [location.key])

  // Admin bar state and logic
  const { 
    activeAccountId, 
    activeAccountType,
    availableAccounts,
    isAdminMode: reduxAdminMode,
    originalAdminId: reduxOriginalAdminId,
    loading
  } = useSelector((state: any) => state.Account)
  const userdata = useSelector((state: any) => state.Auth?.authProfile?.userData)
  
  // Check both localStorage and Redux for admin mode
  const isAdminModeLocal = localStorage.getItem('isAdminMode') === 'true'
  const adminPermissionMode = localStorage.getItem('adminPermissionMode') === 'true'
  const mimicId = localStorage.getItem('mimicId')
  const originalAdminId = localStorage.getItem('originalAdminId')
  const currentUserId = localStorage.getItem('userId')

  // Determine if we should show the admin account indicator
  const isAdminViewing = Boolean(mimicId || isAdminModeLocal || reduxAdminMode)
  
  // Handle admin permission toggle
  const handleToggleAdminPermissions = async () => {
    try {
      await dispatch(toggleAdminPermissionMode())
    } catch (error) {
      console.error('Failed to toggle admin permissions:', error)
    }
  }

  const getCurrentAccountDisplay = () => {
    if (isAdminViewing) {
      // For mimicId (legacy system)
      if (mimicId) {
        return `Administrator viewing: User Account (Legacy Mode)`
      }
      
      // For new admin system
      if (activeAccountType === 'b2b' && activeAccountId) {
        const b2bAccount = availableAccounts?.find((acc: any) => acc.accountId === activeAccountId)
        return `Administrator viewing: ${b2bAccount?.businessName || 'Business Account'}`
      } else if (activeAccountId) {
        // Get the target user's name if available
        const targetUserName = userdata?.firstName && userdata?.lastName 
          ? `${userdata.firstName} ${userdata.lastName}` 
          : 'User Account'
        return `Administrator viewing: ${targetUserName}`
      } else {
        // Fallback when activeAccountId is null but we're in admin mode
        // Check if we have user data with name information
        if (userdata?.businessName) {
          // It's a business account
          return `Administrator viewing: ${userdata.businessName} (Business Account)`
        } else if (userdata?.firstName && userdata?.lastName) {
          // It's a user account with name
          return `Administrator viewing: ${userdata.firstName} ${userdata.lastName} (User Account)`
        } else if (userdata?.firstName) {
          // Has first name only
          return `Administrator viewing: ${userdata.firstName} (User Account)`
        } else {
          // No name info available, use email or fallback
          const identifier = userdata?.protected?.email || userdata?.email || 'Unknown User'
          return `Administrator viewing: ${identifier}`
        }
      }
    }
    return null
  }

  return (
    <>
      {/* Main content - no longer needs margin since admin bar is in normal flow */}
      <div>
        <PageDataProvider>
          <div className='d-flex flex-column flex-root app-root' id='kt_app_root'>
            <div className='app-page flex-column flex-column-fluid' id='kt_app_page'>
              <HeaderWrapper
                props={hasActiveScenes}
              />
              <div className='app-wrapper flex-column flex-row-fluid' id='kt_app_wrapper'>
                {Allcard ? <Sidebar /> : ''}
                <div className='app-main flex-column flex-row-fluid' id='kt_app_main'>
                  {/* Admin Account Indicator - Now inside kt_app_main to push content down naturally */}
                  {isAdminViewing && (
                    <div
                      className='bg-warning text-dark py-3 px-3 d-flex align-items-center justify-content-between fw-bold fs-6 border-bottom' 
                      style={{ 
                        borderBottom: '2px solid #f1c40f'
                      }}
                      title={`Account ID: ${activeAccountId || currentUserId || 'Unknown'} | Original Admin ID: ${originalAdminId || reduxOriginalAdminId || 'Unknown'}`}
                    >
                      <div className='d-flex align-items-center'>
                        <i className='fas fa-shield-alt me-2'></i>
                        <div className='d-flex flex-column'>
                          <span>{getCurrentAccountDisplay()}</span>
                          <span className='text-muted fs-7'>
                            • Use sidebar to return to your admin account
                          </span>
                        </div>
                      </div>
                      
                      {/* Admin Permission Mode Toggle - Only show for new admin system (not legacy mimicId) */}
                      {!mimicId && (
                        <div className='d-flex align-items-center gap-3'>
                          <div className='d-flex flex-column align-items-end me-3'>
                            <span className='fs-7 fw-bold'>View Mode:</span>
                            <span className='fs-8 text-muted'>
                              {adminPermissionMode ? 'Admin Permissions' : 'User Permissions'}
                            </span>
                          </div>
                          <button
                            className={`btn btn-sm ${adminPermissionMode ? 'btn-dark' : 'btn-light-primary'} fw-bold d-flex align-items-center`}
                            onClick={handleToggleAdminPermissions}
                            disabled={loading}
                            title={adminPermissionMode ? 'Switch to User View' : 'Switch to Admin View'}
                          >
                            <i className='fas fa-exchange-alt me-2'></i>
                            {adminPermissionMode ? 'Admin View' : 'User View'}
                          </button>
                        </div>
                      )}
                    </div>
                  )}
                  
                  <div className='d-flex flex-column flex-column-fluid'>
                    <Content>
                      <Outlet />
                    </Content>
                  </div>
                  <FooterWrapper />
                </div>
              </div>
            </div>
          </div>

          {/* begin:: Drawers */}
          <ActivityDrawer />
          {/* <RightToolbar /> */}
          <DrawerMessenger />
          {/* end:: Drawers */}

          {/* begin:: Modals */}
          <InviteUsers />
          <UpgradePlan />
          {/* end:: Modals */}
          {/* <ScrollTop /> */}

          {/*environment === 'staging'
          ? <div style={{fontSize:'15px', width:'100%', padding:'5px', color:'red', height:'40px', position:'fixed', top:'0px', zIndex:1000, background:'white', textAlign:'center', borderTop:'1px solid black'}}>
              You are currently in the staging environment. Anything created here will not be present in production and could be deleted.
            </div>
          : testmode === 'production'
            ? <div style={{fontSize:'15px', padding:'5px', color:'red', width:'100%', height:'40px', position:'fixed', top:'0px', zIndex:1000, background:'white', textAlign:'center', borderTop:'1px solid black'}}>
                You are currently in the production environment. &nbsp;&nbsp;&nbsp;
                <button onClick={handleStagingMode}>Switch to Staging</button> &nbsp;&nbsp;&nbsp;
                <button onClick={handleLocalMode}>Switch to Local</button>
              </div>
            : testmode === 'staging'
              ? <div style={{fontSize:'15px', padding:'5px', color:'red', width:'100%', height:'45px', position:'fixed', top:'0px', zIndex:1000, background:'white', textAlign:'center', borderTop:'1px solid black'}}>
                  You are currently in the staging environment. &nbsp;&nbsp;&nbsp;
                  <button onClick={handleProductionMode}>Switch to Production</button> &nbsp;&nbsp;&nbsp;
                  <button onClick={handleLocalMode}>Switch to Local</button>
                </div>
              : <></>
          */}
        </PageDataProvider>
      </div>
    </>

    )
}

export { MasterLayout }